(function () {
  "use strict";
  var R = window.SABLE || {};
  var addUrl = R.addUrl || "/cart/add.js";
  var changeUrl = R.changeUrl || "/cart/change.js";

  function money(cents) {
    try { return (cents / 100).toLocaleString(undefined, { style: "currency", currency: R.currency || "GBP" }); }
    catch (e) { return "£" + (cents / 100).toFixed(2); }
  }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }

  /* ---------- product state (variants) ---------- */
  var variants = [];
  try { variants = (JSON.parse(($("#SableProductJSON") || {}).textContent || "{}").variants) || []; } catch (e) {}
  var current = variants[0] || null;
  variants.some(function (v) { if (v.available) { current = v; return true; } return false; });

  function findByOption1(val) {
    return variants.filter(function (v) { return v.option1 === val; })[0];
  }

  /* ---------- gallery: swipeable main + thumb strip; arrows step through PHOTOS ---------- */
  (function () {
    var track = $("[data-gtrack]");
    if (!track) return;
    var strip = $("[data-thumbstrip]");
    var slides = $$(".gslide", track);
    var thumbs = strip ? $$(".gthumb", strip) : [];
    var prev = $("[data-thumb-prev]"), next = $("[data-thumb-next]");
    var current = 0, rafMain = null;

    function highlight(i) { thumbs.forEach(function (t, j) { t.classList.toggle("on", j === i); }); }
    function centerThumb(i) {
      if (!strip || !thumbs[i]) return;
      var t = thumbs[i];
      strip.scrollTo({ left: Math.max(0, t.offsetLeft - strip.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2), behavior: "smooth" });
    }
    function updateArrows() {
      if (prev) prev.disabled = current <= 0;
      if (next) next.disabled = current >= slides.length - 1;
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      current = i;
      if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: "smooth" });
      highlight(i); centerThumb(i); updateArrows();
    }
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { goTo(i); }); });
    // swiping the main image keeps everything in sync
    track.addEventListener("scroll", function () {
      if (rafMain) return;
      rafMain = requestAnimationFrame(function () {
        rafMain = null;
        var center = track.scrollLeft + track.clientWidth / 2, idx = 0, best = Infinity;
        slides.forEach(function (s, i) { var d = Math.abs((s.offsetLeft - track.offsetLeft + s.offsetWidth / 2) - center); if (d < best) { best = d; idx = i; } });
        current = idx; highlight(idx); centerThumb(idx); updateArrows();
      });
    });
    // arrows = previous / next PHOTO (advances the main image, strip follows)
    if (prev) prev.addEventListener("click", function () { goTo(current - 1); });
    if (next) next.addEventListener("click", function () { goTo(current + 1); });
    updateArrows();
  })();

  /* ---------- finish / variant select ---------- */
  (function () {
    var btns = $$("#finishes .finish");
    var sel = $("#sel-finish");
    if (!btns.length) return;
    btns.forEach(function (b) {
      b.addEventListener("click", function () {
        var val = b.getAttribute("data-finish");
        btns.forEach(function (t) { t.classList.remove("on"); });
        b.classList.add("on");
        if (sel) sel.textContent = val;
        var v = findByOption1(val);
        if (v) { current = v; reflectVariant(); }
      });
    });
  })();

  function reflectVariant() {
    if (!current) return;
    var idEl = $("[data-variant-id]");
    if (idEl) idEl.value = current.id;
    var now = $("[data-now]");
    if (now) now.textContent = money(current.price);
    var atc = $("[data-atc]");
    if (atc) {
      if (current.available) {
        atc.disabled = false;
        atc.innerHTML = 'Add to cart <span class="p" id="atc-price">· ' + money(current.price * qtyVal()) + '</span>';
      } else {
        atc.disabled = true;
        atc.textContent = "Sold out";
      }
    }
    // was / save chip
    var wasEl = $("[data-was]"), saveEl = $("[data-save]");
    if (current.compare_at_price && current.compare_at_price > current.price) {
      if (wasEl) { wasEl.textContent = money(current.compare_at_price); wasEl.hidden = false; }
      if (saveEl) { saveEl.textContent = "SAVE " + Math.floor((current.compare_at_price - current.price) * 100 / current.compare_at_price) + "%"; saveEl.hidden = false; }
    } else {
      if (wasEl) wasEl.hidden = true;
      if (saveEl) saveEl.hidden = true;
    }
    applyBundlePrice();
  }

  /* ---------- bundle picker (sets quantity) ---------- */
  var qv = 1;
  function qtyVal() { return qv; }
  function applyBundlePrice() {
    var on = document.querySelector("[data-bundles] .bundle.on");
    var total = on ? parseInt(on.getAttribute("data-total"), 10) : NaN;
    var p = $("#atc-price");
    if (p) p.textContent = "· " + (isNaN(total) ? money((current ? current.price : 0) * qv) : money(total));
    var sp = $(".stickybar__p b");
    if (sp && !isNaN(total)) sp.textContent = money(total);
  }
  (function () {
    var wrap = $("[data-bundles]");
    if (!wrap) return;
    var tiles = $$(".bundle", wrap);
    var input = $("[data-qty-input]");
    function select(t) {
      tiles.forEach(function (x) { var on = x === t; x.classList.toggle("on", on); x.setAttribute("aria-pressed", on ? "true" : "false"); });
      qv = parseInt(t.getAttribute("data-qty"), 10) || 1;
      if (input) input.value = qv;
      applyBundlePrice();
    }
    tiles.forEach(function (t) { t.addEventListener("click", function () { select(t); }); });
    var on = wrap.querySelector(".bundle.on") || tiles[0];
    if (on) select(on);
  })();

  /* ---------- cart drawer ---------- */
  var drawer = $("[data-cart-drawer]");
  var scrim = $("[data-cd-scrim]");
  function cartOpen() { document.body.classList.add("cd-open"); if (drawer) drawer.setAttribute("aria-hidden", "false"); }
  function cartClose() { document.body.classList.remove("cd-open"); if (drawer) drawer.setAttribute("aria-hidden", "true"); }

  function renderCart(cart) {
    var count = cart.item_count;
    $$("[data-cart-count]").forEach(function (el) { el.textContent = count; });
    var cd = $("[data-cd-count]"); if (cd) cd.textContent = "(" + count + ")";
    var items = $("[data-cd-items]"), empty = $("[data-cd-empty]"), foot = $("[data-cd-foot]"), sub = $("[data-cd-subtotal]");
    if (!items) return;
    if (count === 0) {
      items.innerHTML = "";
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;
    if (sub) sub.textContent = money(cart.total_price);
    items.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") + '" alt="" class="cdi__img">' : '<div class="cdi__img cdi__img--ph"></div>';
      var opts = (it.options_with_values || []).map(function (o) { return o.value; }).filter(function (v) { return v && v !== "Default Title" && v !== "Default"; }).join(" · ");
      return '<div class="cdi" data-key="' + it.key + '">' +
        img +
        '<div class="cdi__main">' +
          '<div class="cdi__t">' + it.product_title + '</div>' +
          (opts ? '<div class="cdi__o">' + opts + '</div>' : '') +
          '<div class="cdi__b">' +
            '<div class="cdi__qty">' +
              '<button type="button" data-cd-step="-1" aria-label="Decrease">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-cd-step="1" aria-label="Increase">+</button>' +
            '</div>' +
            '<span class="cdi__price">' + money(it.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="cdi__rm" data-cd-remove>Remove</button>' +
        '</div>' +
      '</div>';
    }).join("");
  }

  function refresh() {
    return fetch(R.cartUrl ? "/cart.js" : "/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(renderCart).catch(function () {});
  }

  function change(key, qty) {
    return fetch(changeUrl, {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  if (drawer) {
    $$("[data-cart-toggle]").forEach(function (el) {
      el.addEventListener("click", function (e) { e.preventDefault(); cartOpen(); refresh(); });
    });
    $$("[data-cd-close]").forEach(function (el) { el.addEventListener("click", cartClose); });
    if (scrim) scrim.addEventListener("click", cartClose);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") cartClose(); });
    var itemsEl = $("[data-cd-items]");
    if (itemsEl) itemsEl.addEventListener("click", function (e) {
      var row = e.target.closest(".cdi"); if (!row) return;
      var key = row.getAttribute("data-key");
      var step = e.target.closest("[data-cd-step]");
      if (step) { var cur = +row.querySelector(".cdi__qty span").textContent || 1; change(key, Math.max(0, cur + (+step.getAttribute("data-cd-step")))); return; }
      if (e.target.closest("[data-cd-remove]")) change(key, 0);
    });
  }

  /* ---------- add to cart (AJAX) ---------- */
  (function () {
    var form = $("#sable-form");
    if (!form) return;
    form.addEventListener("submit", function (e) {
      // let the dynamic-checkout (payment) button do its own thing
      if (e.submitter && e.submitter.classList && e.submitter.classList.contains("shopify-payment-button__button")) return;
      e.preventDefault();
      var btn = $("[data-atc]");
      if (btn && btn.disabled) return;
      var label = btn ? btn.innerHTML : "";
      if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
      fetch(addUrl, {
        method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: ($("[data-variant-id]") || {}).value || (current && current.id), quantity: qtyVal() })
      }).then(function (r) { return r.json(); })
        .then(function () { return refresh(); })
        .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } cartOpen(); })
        .catch(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } form.submit(); });
    });
    var sticky = $("[data-sticky-add]");
    if (sticky) sticky.addEventListener("click", function () {
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
    });
  })();

  /* ---------- sticky add-to-cart bar ---------- */
  (function () {
    var bar = $("#stickybar");
    var atc = $(".hero .atc");
    if (!bar || !atc || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var en = entries[0];
      var show = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle("show", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
    }, { threshold: 0 });
    io.observe(atc);
  })();

  /* ---------- mobile menu (full-screen overlay) ---------- */
  (function () {
    var burger = $("[data-menu-toggle]");
    if (!burger) return;
    function setOpen(open) {
      document.body.classList.toggle("menu-open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    }
    burger.addEventListener("click", function () { setOpen(!document.body.classList.contains("menu-open")); });
    $$("[data-menu-close]").forEach(function (el) { el.addEventListener("click", function () { setOpen(false); }); });
    $$(".mmenu a").forEach(function (a) { a.addEventListener("click", function () { setOpen(false); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && document.body.classList.contains("menu-open")) setOpen(false); });
  })();

  document.addEventListener("DOMContentLoaded", function () { reflectVariant(); refresh(); });
})();
